import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, Input } from '@angular/core';
import { BrandService } from 'brand';
import { CurvedBoxComponent } from 'curved-box';
import { SvgComponent } from 'icon';
import { LinkComponent } from 'link';
import { FooterCTAAreaSlice } from '../footer.class';

@Component({
  selector: 'lib-footer-cta-area',
  templateUrl: './footer-cta-area.component.html',
  imports: [SvgComponent, LinkComponent, CurvedBoxComponent, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterCtaAreaComponent {
  public brand = inject<BrandService>(BrandService);
  @Input() public slice: FooterCTAAreaSlice;
  public lightTheme = input(false);
}
